import Header from './header'

const header = new Header()
header.init()
